import { Helmet } from 'react-helmet-async';
import { ErrorBoundary } from '@sentry/react';

// TODO: All app-related entities should be moved to the app-context library
import { ConfigContextProvider } from '@occc/config';
import { SomethingWrong } from '@occc-app/App/AppContext/components/SomethingWrong';
import { LoadingOverlay } from '@occc-app/design-system';

import { AppInitializer } from './AppInitializer';
import { AppRouter } from './routes/AppRouter';

const App = () => (
  <>
    <Helmet>
      <title>Activate Command Center</title>
    </Helmet>
    <ErrorBoundary>
      <ConfigContextProvider
        renderError={() => <SomethingWrong />}
        renderLoading={() => <LoadingOverlay loaderSize={120} />}
      >
        <AppInitializer>
          <AppRouter />
        </AppInitializer>
      </ConfigContextProvider>
    </ErrorBoundary>
  </>
);

export default App;
